'use strict';

var React = require('react');

var SvgFeaturedContentMajor = function SvgFeaturedContentMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 5.25c0-.69.56-1.25 1.25-1.25h2.25v3.75c0 .966.784 1.75 1.75 1.75h3.75v1.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.22-.53l-5.5-5.5a.75.75 0 0 0-.53-.22h-3a2.75 2.75 0 0 0-2.75 2.75v9.5a2.75 2.75 0 0 0 2.75 2.75h1.25a.75.75 0 0 0 0-1.5h-1.25c-.69 0-1.25-.56-1.25-1.25v-9.5Zm7.94 2.75-2.94-2.94v2.69c0 .138.112.25.25.25h2.69Zm-2.228 6.464a.766.766 0 0 1 1.061 0l.453.442a.75.75 0 0 0 1.048 0l.453-.442a.766.766 0 0 1 1.061 0 .688.688 0 0 1 0 .992l-2.038 1.995-2.038-1.995a.688.688 0 0 1 0-.992Zm2.038-1.14a2.266 2.266 0 0 0-3.087.068 2.188 2.188 0 0 0 0 3.137l2.213 2.165a1.25 1.25 0 0 0 1.748 0l2.213-2.165a2.188 2.188 0 0 0 0-3.137 2.266 2.266 0 0 0-3.087-.068Z"
  }));
};
SvgFeaturedContentMajor.displayName = "FeaturedContentMajor";

exports.SvgFeaturedContentMajor = SvgFeaturedContentMajor;
